import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BillService } from 'src/app/services/core/quickbook/bills/bill.service';
import { BillPaymentService } from 'src/app/services/core/quickbook/bill-payments/bill-payment.service';
import { getAmountPaid, getBillPaymentTypeLabel, getPaymentStatus, getRemainingBalance } from 'src/app/utils/common.utils';
import { sweetAlert } from 'src/app/utils/swal';

@UntilDestroy()

@Component({
  selector: 'app-bill-detail-modal',
  templateUrl: './bill-detail-modal.component.html',
  styleUrls: ['./bill-detail-modal.component.css']
})
export class BillDetailModalComponent implements OnInit {

  @Input() billDetail: any;
  @Output() closeModal = new EventEmitter<any>();
  @Output() updated = new EventEmitter<any>();
  billPayments: any[] = [];
  getPaymentStatus = getPaymentStatus;
  getAmountPaid = getAmountPaid;
  getRemainingBalance = getRemainingBalance;
  getBillPaymentTypeLabel = getBillPaymentTypeLabel;

  constructor(
    private billService: BillService,
    private billPaymentService: BillPaymentService
  ) {}

  ngOnInit(): void {
    this.getBillPayments();
  }

  getBillPayments() {
    if (!this.billDetail?.id || !this.billDetail?.Id) {
      this.billPayments = [];
      return;
    }
    this.billPaymentService.getBillPayments({
      bill: this.billDetail.id,
      limit: 9999,
      sortBy: 'createdAt:desc'
    }).pipe(untilDestroyed(this)).subscribe((data: any) => {
      this.billPayments = data?.[0]?.data || data?.results || [];
    });
  }

  refreshBill() {
    this.billService.getBillById(this.billDetail.id).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.billDetail = data;
      }
      this.getBillPayments();
      this.updated.emit();
    });
  }

  canPushPayment(payment: any) {
    return !!(payment && !payment.Id && this.billDetail?.Id);
  }

  canVoidPayment(payment: any) {
    return !!(payment?.Id && getPaymentStatus(this.billDetail) === 'Paid' && +payment.TotalAmt > 0);
  }

  async onVoidPayment(payment: any) {
    const result = await sweetAlert('Alert', 'Void this payment? The bill balance will be restored.', 'warning', 'Yes', 'No');
    if (!result.value) return;
    this.billPaymentService.voidPayment(payment.id).pipe(untilDestroyed(this)).subscribe({
      next: () => this.refreshBill(),
      error: (err) => sweetAlert('Error', err, 'error', 'Ok')
    });
  }

  async onDeletePayment(payment: any) {
    const result = await sweetAlert('Alert', 'Delete this payment? The bill balance will be restored.', 'warning', 'Yes', 'No');
    if (!result.value) return;
    this.billPaymentService.deletePayment(payment.id).pipe(untilDestroyed(this)).subscribe({
      next: () => this.refreshBill(),
      error: (err) => sweetAlert('Error', err, 'error', 'Ok')
    });
  }

  async onSyncPayment(payment: any) {
    if (!this.canPushPayment(payment)) return;
    const result = await sweetAlert(
      'Alert',
      'Are you sure you want to overwrite the QuickBooks data with bill payment data',
      'warning',
      'Yes',
      'No'
    );
    if (!result.value) return;
    this.billPaymentService.syncBillPayment(payment.id, { isSyncFrom: false }).pipe(untilDestroyed(this)).subscribe({
      next: () => this.refreshBill(),
      error: (err) => sweetAlert('Error', err, 'error', 'Ok')
    });
  }

  onCloseModal() {
    this.closeModal.emit();
  }
}
